<template>
  <div>
    <footer class="page-footer font-small pt-4">
      <div
        class="container-fluid text-center text-md-left "
        style="padding: 0 0 0 0;"
      >
        <h2 class="text-center mb-5 mt-5 font-weight-bold">
          What is Dropsmart?
        </h2>

        <div class="row resposive-info-content">
          <div class="col-md mb-md-0 mb-3">
            <h5 class="font-weight-bold">Footer text 1</h5>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio
              deserunt fuga perferendis modi earum commodi aperiam temporibus
              quod nulla nesciunt aliquid debitis ullam omnis quos ipsam,
              aspernatur id excepturi hic.
            </p>
          </div>

          <hr class="clearfix w-100 d-md-none pb-3" />

          <div class="col-md mb-md-0 mb-3">
            <h5 class="font-weight-bold">Footer text 2</h5>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio
              deserunt fuga perferendis modi earum commodi aperiam temporibus
              quod nulla nesciunt aliquid debitis ullam omnis quos ipsam,
              aspernatur id excepturi hic.
            </p>
          </div>

          <hr class="clearfix w-100 d-md-none pb-3" />

          <div class="col-md mb-md-0 mb-3">
            <h5 class="font-weight-bold">Footer text 3</h5>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio
              deserunt fuga perferendis modi earum commodi aperiam temporibus
              quod nulla nesciunt aliquid debitis ullam omnis quos ipsam,
              aspernatur id excepturi hic.
            </p>
          </div>
        </div>

        <div style="background-color: #E7E7E7;">
          <div class="row responsive-footer-links mt-5 pt-5 pb-5">
            <div class="col-md-3 mb-md-0 mb-3">
              <h5 class="font-weight-bold">Shop</h5>

              <ul class="list-unstyled">
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
              </ul>
            </div>

            <div class="col-md-3 mb-md-0 mb-3">
              <h5 class="font-weight-bold">Sell</h5>

              <ul class="list-unstyled">
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
              </ul>
            </div>

            <div class="col-md-3 mb-md-0 mb-3">
              <h5 class="font-weight-bold">About</h5>

              <ul class="list-unstyled">
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
              </ul>
            </div>

            <div class="col-md-3 mb-md-0 mb-3">
              <h5 class="font-weight-bold">Help</h5>

              <ul class="list-unstyled">
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-copyright text-center py-3 last-footer-section">
        <div class="max-view-width">
          <div class="word-spacing">
            <b-icon-globe variant="dark"></b-icon-globe>
            Croatia | English(UK) | €(EUR)
          </div>
          <div class="link-spacing">
            © 2022 Dropsmart
            <a href="#" class="text-body">Terms of Use</a>
            <a href="#" class="text-body">Privace</a>
            <a href="#" class="text-body">Cookies</a>
            <a href="#" class="text-body">Interest-based ads</a>
            <a href="#" class="text-body">Regions</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "MarketplaceFooter",
};
</script>

<style scoped lang="scss">
.last-footer-section {
  display: block;
  margin: 0 210px;
}

.max-view-width {
  max-width: 1000px;
  margin-right: -210px;
  display: flex;
  justify-content: space-between;
}

.word-spacing {
  word-spacing: 0.5rem;
}

.link-spacing a {
  margin-left: 1rem;
}

div.row.resposive-info-content,
div.row.responsive-footer-links {
  margin: 0 210px;
}

@media screen and (max-width: 1023px) {
  div.row.resposive-info-content,
  div.row.responsive-footer-links,
  .last-footer-section {
    margin: 0 1rem;
  }
}

@media screen and (max-width: 1439px) {
  .max-view-width {
    display: block;
    margin-right: 0;
  }
}

@media screen and (min-width: 1441px) {
  .max-view-width {
    max-width: 100%;
    margin-right: 0;
  }
}
</style>
